import moment from 'moment';

export const isEmpty = (value: any) => {
  return (
    value === null ||
    value === undefined ||
    value.length === 0 ||
    (typeof value === 'object' && Object.keys(value).length === 0)
  );
};

export const isPlural = (value: number | string | any[]) => {
  if (typeof value === 'number') return value === 0 || value > 1 ? 's' : '';
  return value?.length > 1 ? 's' : '';
};

export const getPluralWord = (value: number | string | any[], word: string) => {
  const ending = isPlural(value);

  if (word === 'person') {
    return isEmpty(ending) ? 'person' : 'people';
  }

  return word + ending;
};

export const getPluralPhrase = (
  value: number | string | any[],
  word: string,
  middleText?: string,
) => {
  const num = typeof value === 'number' ? value : value?.length;

  return (
    num +
    (middleText ? ' ' + middleText : '') +
    ' ' +
    getPluralWord(value, word)
  );
};

export const round = (value: number, isToDecimal?: boolean) => {
  if (isToDecimal) return Math.round(value * 100) / 100;
  return Math.ceil(value);
};

export const getPct = (value: number) => {
  return Math.round(value * 100 * 10) / 10;
};

export const getDuration = (
  length: number,
  isWholeMin?: boolean,
  isShort?: boolean,
) => {
  const min = Math.floor(length / 60);
  const sec = Math.round(length % 60);

  if (isWholeMin) return Math.round(length / 60) + ' min';

  return (
    (min ? min + ' min ' : '') +
    (sec ? sec + (isShort ? ' sec' : ' seconds') : '')
  );
};

export const msecToSec = (milliseconds?: number) => {
  if (!milliseconds) return 0;
  return milliseconds / 1000;
};

export const formatDate = (date: string) => {
  return moment(date).format('D MMM YYYY');
};

export const toTitleCase = (text: string) => {
  return text.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const getHashTagText = (hashTag: string[]) => {
  return hashTag.map((tag) => '#' + tag).join(' ') ?? '';
};
